import React from 'react';

const HealthCallToAction = () => {
  return (
    <div className="health-main-wrapper float_left">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="sb-health-main-sec">
              <h4>
                Need to Take Care of Your <br />
                <span>Family Health</span>
              </h4>
              <p className="my-4">
                It is a long established fact that a reader will be distracted by the
                readable<br /> content of a page when looking at its layout.
              </p>
              <a href="service.html" className="page2-btn bg-white">
                View all service
              </a>
              <a href="contact-us.html" className="page2-btn">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthCallToAction;
